import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const r = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() })
      });
      const d = await r.json();
      if (d.success) setSent(true);
      else setError(d.error || 'Fehler beim Senden');
    } catch { setError('Verbindungsfehler'); }
    finally { setLoading(false); }
  }

  const base = {
    minHeight: '100vh',
    background: 'radial-gradient(ellipse at top, #1a1a1a 0%, #0a0a0a 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", sans-serif',
    color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem'
  };

  return (
    <div style={base}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.09)', borderRadius: 24, padding: '2.25rem', boxShadow: '0 24px 60px rgba(0,0,0,0.4)', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3, background: 'linear-gradient(90deg, #f7d98f, #d9aa43)', borderRadius: '24px 24px 0 0' }} />

          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <img src="/logo.webp" alt="TDA" style={{ width: 64, height: 64, borderRadius: 16, marginBottom: '1rem', boxShadow: '0 8px 24px rgba(0,0,0,0.3)' }} />
            <h2 style={{ margin: '0 0 0.25rem', fontSize: '1.4rem', fontWeight: 700 }}>Passwort vergessen?</h2>
            <p style={{ margin: 0, color: 'rgba(255,255,255,0.4)', fontSize: '0.875rem' }}>
              {sent ? 'E-Mail gesendet' : 'Wir senden Ihnen einen Reset-Link'}
            </p>
          </div>

          {sent ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📬</div>
              <p style={{ color: '#34d399', fontWeight: 600, marginBottom: '0.5rem' }}>E-Mail gesendet!</p>
              <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.875rem', marginBottom: '1.5rem' }}>
                Falls die Adresse bekannt ist, erhalten Sie in Kürze einen Reset-Link (gültig 1 Stunde).
              </p>
              <button onClick={() => navigate('/login')} style={{ width: '100%', padding: '0.875rem', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 12, color: '#fff', fontSize: '0.875rem', cursor: 'pointer', fontFamily: 'inherit' }}>
                Zurück zum Login
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.72rem', fontWeight: 600, color: 'rgba(255,255,255,0.5)', marginBottom: '0.5rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  E-Mail-Adresse
                </label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="ihre@email.de" required disabled={loading}
                  style={{ width: '100%', boxSizing: 'border-box', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 12, padding: '0.75rem 1rem', color: '#fff', fontSize: '0.95rem', outline: 'none', fontFamily: 'inherit' }} />
              </div>

              {error && (
                <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 10, padding: '0.7rem 1rem', color: '#fca5a5', fontSize: '0.85rem' }}>{error}</div>
              )}

              <button type="submit" disabled={loading} style={{ padding: '0.875rem', background: loading ? 'rgba(139,90,18,0.5)' : 'linear-gradient(135deg, #f7d98f, #8b5a12)', border: 'none', borderRadius: 12, color: '#0b0c10', fontWeight: 700, fontSize: '0.9rem', cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit' }}>
                {loading ? 'Sende…' : 'Reset-Link anfordern'}
              </button>

              <button type="button" onClick={() => navigate('/login')} style={{ padding: '0.75rem', background: 'transparent', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 12, color: 'rgba(255,255,255,0.5)', fontSize: '0.875rem', cursor: 'pointer', fontFamily: 'inherit' }}>
                Zurück zum Login
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
